import {CombinedState, combineReducers, Reducer} from "redux";
import {AppState} from "../types/app";
import {WheelState} from "../types/wheel";
import appReducer from "./app";
import wheelReducer from "./wheel";

export interface IStore {
  app: AppState,
  wheel: WheelState,
}

export const rootReducer: Reducer<CombinedState<IStore>> = combineReducers({
  app: appReducer,
  wheel: wheelReducer,
});
